import React from 'react';
import PropTypes from 'prop-types';

// import api

// import contexts

// import hooks
import useBodyScrollToTop from '@/hooks/useBodyScrollToTop';

// import components
import ButtonLink from '@/components/atoms/ButtonLink';

const ThankYou = ({ title, content, backCta, backFn }) => {
  useBodyScrollToTop();
  return (
    <div className='dln-wrapper dln-wrapper--thankYouMessage'>
      <h2 className='dln-contactUs__title'>{title}</h2>
      <div className='dln-contactUs__thankYouMessage'>
        <span className='dln-contactUs__thankYouMessageIconWrap'>
          <i className='dln-icn dln-icn--iconfont dln-icn--check-circle dln-icn--T'>
            T
          </i>
        </span>
        <div className='dln-contactUs__thankYouMessageWrap'>
          <p
            className='dln-contactUs__thankYouMessageText'
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>
      </div>
      <ButtonLink
        modifiers={['backToContactUs']}
        text={backCta}
        onClick={backFn}
      />
    </div>
  );
};

ThankYou.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  backCta: PropTypes.string,
  backFn: PropTypes.func,
};

ThankYou.defaultProps = {
  title: null,
  content: null,
  backCta: null,
  backFn: null,
};

export default ThankYou;
